const CONSTANTS = {
  STRIPE_API_VERSION: '2022-08-01',
  AD_PREBUMP: 'https://cdn.acast.com/acast-northstar-a.mp3',
  MAX_UPLOAD_FILE_SIZE_STARTER: 150 * 1024 * 1024, // 150 MB
  MAX_UPLOAD_FILE_SIZE_PAID_PLAN: 900 * 1024 * 1024, // 900 MB
  MAX_UPLOAD_FILE_SIZE_DEFAULT: 200 * 1024 * 1024, // 200 MB
  MAX_IMPORT_FILE_SIZE: 200 * 1024 * 1024, // 200 MB
  DONT_UPGRADE_PLANS: ['private-feed', 'private-feed-yearly', 'free-forever'],
  FREE_TRIAL_DAYS: 14,
  FEED_VERSION: '1.2.0',
  FIRST_MIDROLL_DURATION_THRESHOLD: 600, // 10 minutes
  SECOND_MIDROLL_DURATION_THRESHOLD: 1200, // 20 minutes
  IMPORTER_TIMEOUT: 1000 * 60 * 5, // 5 mins
  LEGACY_MERKER_CUT_OFF_DATE: '2021-05-05 13:14:00',
  LEGACY_MARKER_TOLERANCE: 10, // 10 second marker tolerance
  POSTROLL_START_TIME: 9999,
  MAX_CHARACTERS_PER_EPISODE: 4000,
  MAX_CHARACTERS_PER_SHOW: 4000,
  DELETED_EPISODE_EXPIRATION_TIME: 60 * 60 * 24 * 90,
  DELETED_TRANSCRIPTION_METADATA_EXPIRATION_TIME: 60 * 60 * 24 * 30,
  RESTORATION_TIMESTAMP: new Date('01.01.2100').getTime(),
  TRANSCRIPT_END_DATE: new Date('2022-11-22').getTime(),
  PATREON_END_DATE: new Date('2025-01-13').getTime(),
  SHOW_LIMIT_FOR_FREE_PLAN: 1,
  EPISODE_LIMIT_FOR_FREE_PLAN: 5,
  PROFILE_MAX_INTERESTS: 10,
  PROFILE_MAX_NEW_INTERESTS_LENGTH: 30,
  PROFILE_MIN_INTERESTS: 3,
  MARKETPLACE_THRESHOLD_LISTENS: 1000,
  MARKETPLACE_RETRY_AFTER_DAYS: 30,
  GLOBAL_EPISODE_DESCRIPTION_MAX_LENGTH: 1000,
  ALIAS_MAX_LENGTH: 256,
  MARKETPLACE_PROFILE_TYPES: {
    PODCAST: 'profile',
    HOST: 'hosts',
  },
  PHYLLO: {
    PLATFORMS: {
      FACEBOOK: 'ad2fec62-2987-40a0-89fb-23485972598c',
      INSTAGRAM: '9bb8913b-ddd9-430b-a66a-d74d846e6c66',
      TIKTOK: 'de55aeec-0dc8-4119-bf90-16b3d1f0c987',
      YOUTUBE: '14d9ddf5-51c6-415e-bde6-f8ed36ad7054',
    },
    STATUS: {
      CONNECTED: 'CONNECTED',
      EXPIRED: 'SESSION_EXPIRED',
      NOT_CONNECTED: 'NOT_CONNECTED',
    },
    PLATFORM_NAMES: ['facebook', 'instagram', 'tiktok', 'youtube'],
  },
  TRANSCRIPT: {
    STATUS: {
      PROCESSING: 'processing',
      COMPLETED: 'completed',
      FAILED: 'failed',
    },
    SUPPORTED_LANGUAGES: ['en', 'es', 'fr', 'de', 'nl', 'it', 'no', 'sv'],
  },
  APPLE_PODCAST: {
    STATUS: {
      DRAFTING: 'DRAFTING',
      PUBLISHED: 'PUBLISHED',
      ARCHIVED: 'ARCHIVED',
      REJECTED: 'REJECTED',
      UNSPECIFIED: 'UNSPECIFIED',
      REMOVED_ISSUE_FOUND: 'REMOVED_ISSUE_FOUND',
      ARCHIVED_AND_REMOVED_ISSUE_FOUND: 'ARCHIVED_AND_REMOVED_ISSUE_FOUND',
      REMOVED_BY_CREATOR: 'REMOVED_BY_CREATOR',
      UNRECOGNIZED: 'UNRECOGNIZED',
    },
  },
};

export default CONSTANTS;
